import { IEmail, IMessagingApi } from '../interfaces';
import { BaseApi } from './base';
import { MessagingApiUrls } from './utils';

export class MessagingApi extends BaseApi implements IMessagingApi {
  sendEmail = (email: IEmail, withAuth: boolean): Promise<void> => {
    return this.post(MessagingApiUrls.sendEmail(), email, { withAuth });
  };
}
